module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/single-product/details/product-details.component.css
// module id = ./src/app/products/single-product/details/product-details.component.css
// module chunks = main